<template>
  <div style="background: url(/static/image/bg123456.jpg) top center no-repeat !important">
    <div class="redEnveBody">
      <div class="redEnveBodyToo">
        <div class="redEnveBodyMain center">
          <div class="redEnveBodyTop">
            <div class="pen"><img src="/static/image/pen.png" /></div>
            <div class="hongbao"></div>
            <div class="jinbi"></div>
            <div class="jinbi2"></div>
            <div class="jinbi3"></div>
            <div class="caidai"></div>
            <div class="lcaidai"></div>
          </div>
          <div class="redEnveFont"><img alt="" src="/static/image/qianghb.png" /></div>
          <div class="toddyTotal"></div>
          <!-- <div class="redEnveTime" v-if="false">
            <div class="time">
              <span id="dd">00</span>: <span id="hh">00</span>
              <div class="redEnveClock redEnveClock2">
                <div id="ready" style="display: none">
                  <div data-wow-duration="0.35s" data-wow-delay="0.35s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.35s; animation-delay: 0.35s; animation-name: zoomInLeft">始</div>
                  <div data-wow-duration="0.30s" data-wow-delay="0.30s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.3s; animation-delay: 0.3s; animation-name: zoomInLeft">开</div>
                  <div data-wow-duration="0.25s" data-wow-delay="0.25s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.25s; animation-delay: 0.25s; animation-name: zoomInLeft">包</div>
                  <div data-wow-duration="0.20s" data-wow-delay="0.20s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.2s; animation-delay: 0.2s; animation-name: zoomInLeft">红</div>
                  <div data-wow-duration="0.15s" data-wow-delay="0.15s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.15s; animation-delay: 0.15s; animation-name: zoomInLeft">离</div>
                  <div data-wow-duration="0.10s" data-wow-delay="0.10s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.1s; animation-delay: 0.1s; animation-name: zoomInLeft">距</div>
                </div>
                <div id="starting" style="display: none">
                  <div data-wow-duration="0.35s" data-wow-delay="0.35s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.35s; animation-delay: 0.35s; animation-name: zoomInLeft">束</div>
                  <div data-wow-duration="0.30s" data-wow-delay="0.30s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.3s; animation-delay: 0.3s; animation-name: zoomInLeft">结</div>
                  <div data-wow-duration="0.25s" data-wow-delay="0.25s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.25s; animation-delay: 0.25s; animation-name: zoomInLeft">包</div>
                  <div data-wow-duration="0.20s" data-wow-delay="0.20s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.2s; animation-delay: 0.2s; animation-name: zoomInLeft">红</div>
                  <div data-wow-duration="0.15s" data-wow-delay="0.15s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.15s; animation-delay: 0.15s; animation-name: zoomInLeft">离</div>
                  <div data-wow-duration="0.10s" data-wow-delay="0.10s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.1s; animation-delay: 0.1s; animation-name: zoomInLeft">距</div>
                </div>
                <div id="red-packet-finish" style="display: none">
                  <div data-wow-duration="0.30s" data-wow-delay="0.30s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.3s; animation-delay: 0.3s; animation-name: zoomInLeft">完</div>
                  <div data-wow-duration="0.25s" data-wow-delay="0.25s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.25s; animation-delay: 0.25s; animation-name: zoomInLeft">抢</div>
                  <div data-wow-duration="0.20s" data-wow-delay="0.20s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.2s; animation-delay: 0.2s; animation-name: zoomInLeft">已</div>
                  <div data-wow-duration="0.15s" data-wow-delay="0.15s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.15s; animation-delay: 0.15s; animation-name: zoomInLeft">包</div>
                  <div data-wow-duration="0.10s" data-wow-delay="0.10s" class="wow zoomInLeft animated" style="visibility: visible; animation-duration: 0.1s; animation-delay: 0.1s; animation-name: zoomInLeft">红</div>
                </div>
                <div id="finish" style="display: block">
                  <div data-wow-duration="0.30s" data-wow-delay="0.30s" class="wow zoomInLeft" style="visibility: visible; animation-duration: 0.3s; animation-delay: 0.3s; animation-name: zoomInLeft">束</div>
                  <div data-wow-duration="0.25s" data-wow-delay="0.25s" class="wow zoomInLeft" style="visibility: visible; animation-duration: 0.25s; animation-delay: 0.25s; animation-name: zoomInLeft">结</div>
                  <div data-wow-duration="0.20s" data-wow-delay="0.20s" class="wow zoomInLeft" style="visibility: visible; animation-duration: 0.2s; animation-delay: 0.2s; animation-name: zoomInLeft">已</div>
                  <div data-wow-duration="0.15s" data-wow-delay="0.15s" class="wow zoomInLeft" style="visibility: visible; animation-duration: 0.15s; animation-delay: 0.15s; animation-name: zoomInLeft">包</div>
                  <div data-wow-duration="0.10s" data-wow-delay="0.10s" class="wow zoomInLeft" style="visibility: visible; animation-duration: 0.1s; animation-delay: 0.1s; animation-name: zoomInLeft">红</div>
                </div>
              </div>
              <span id="mm">00</span>: <span id="ss">00</span>
            </div>
            <div class="time2"><span>天</span> <span>时</span> <span>分</span> <span>秒</span></div>
          </div> -->
          <div class="receiveTimes" style="margin-top: 30px">
            <p style="text-align: center">
              {{$t('Redenvelope.Remaining')}}&nbsp;<span id="remainNum" class="yellow" style="font-size: 32px">{{ userredpacket.sendnums < 0 ? 0 : userredpacket.sendnums }}</span
              >&nbsp;{{$t('Redenvelope.bout')}}，{{$t('Redenvelope.Received')}}&nbsp;<span id="currentNum" class="yellow" style="font-size: 32px">{{ userredpacket.acquirednum }}</span
              >&nbsp;{{$t('Redenvelope.bout')}}
            </p>
          </div>
          <div class="currReceiveTimes">
            <p style="text-align: center">
              {{$t('Redenvelope.Currently')}}&nbsp;<span class="yellow3" style="font-size: 29px">{{ userredpacket.max_times }}</span
              >&nbsp;{{$t('Redenvelope.bout')}}， <span id="maxMsg"> {{$t('Redenvelope.meet')}} </span>
            </p>
          </div>
          <div class="redEnveButtons" @click="changShow"></div>
          <div class="activityInfo" style="margin-top: 230px">
            <div class="activityTop wow zoomIn" style="visibility: visible; animation-name: zoomIn"></div>
            <table id="activityTable" v-if="userredpacket.rules.length > 0">
              <tbody>
                <tr>
                  <td style="border-radius: 17px 0px 0px">{{$t('Redenvelope.activity')}}</td>
                  <td>{{$t('Redenvelope.amount')}}</td>

                  <td style="border-radius: 0px 17px 0px 0px">{{$t('Redenvelope.Number')}}</td>
                </tr>
                <tr v-for="(item, index) in userredpacket.rules" :key="index">
                  <td>{{ item.start_time }} ~ {{ item.end_time }}</td>
                  <td>{{ item.day_flow }}-{{ item.flow_money }}</td>

                  <td>{{ Math.floor(item.recharge) }}</td>
                </tr>
              </tbody>
            </table>
            <div class="activityBot wow flipInX" style="visibility: visible; animation-name: flipInX; line-height: 2">
              <h3 class="yellow">{{$t('Redenvelope.Collection')}}：</h3>
              <p>{{$t('Redenvelope.After')}}<span class="yellow">{{$t('Redenvelope.Second')}}</span>{{$t('Redenvelope.you')}}</p>
              <p>{{$t('Redenvelope.Conditions')}}</p>
            </div>
          </div>
          <div class="h400"></div>
          <div class="activityDes">
            <div class="activityDesTop wow zoomIn" style="visibility: visible; animation-name: zoomIn"></div>
            <div class="activityDesMain">
              <p style="text-align: center">
                <strong>{{ $store.state.appInfo.title }}</strong>
              </p>
              <p>
                <strong>{{$t('Redenvelope.Note')}}<strong style="white-space: normal">{{$t('Redenvelope.Grabred')}}</strong>{{$t('Redenvelope.Beijing')}}</strong><br />{{$t('Redenvelope.Daily')}}<br />
              </p>
              <p>{{$t('Redenvelope.Members')}}</p>
              <p>{{$t('Redenvelope.All')}}</p>
              <p>3、{{ $store.state.appInfo.title }}{{$t('Redenvelope.rights')}}</p>
              <p><br /></p>
            </div>
          </div>
        </div>
      </div>
      <div class="botLeft wow bounceInLeft" style="visibility: visible; animation-name: bounceInLeft"><img src="/static/image/botLeft.png" /></div>
      <div class="botright"><img src="/static/image/botRight.png" class="wow bounceInRight" style="visibility: visible; animation-name: bounceInRight" /></div>
    </div>
    <div id="box1" picfloat="right" class="rightFloat" style="position: fixed; z-index: 1000; top: 365px; right: 0.25px; width: 183px">
      <a href="javascript:;" class="myRedEnves" @click="$parent.goNav('/welfare')"></a> <a href="javascript:;" @click="$parent.openKefu" class="myService"></a>
    </div>

    <!-- 红包还未开始 已结束 -->
    <div class="weikaishi divIndex" v-if="weikaishi">
      <p>{{$t('Redenvelope.event')}}</p>
      <a href="javascript:;" @click="closeAll" class="close"></a>
    </div>
    <div class="qiangwan divIndex" v-if="end">
      <p>{{$t('Redenvelope.Please')}}</p>
      <a href="javascript:;" @click="closeAll" class="close"></a>
    </div>
    <!-- 中奖了 -->
    <div class="zhongjiang divIndex" v-if="zhongjiang">
      <p>{{$t('Redenvelope.Congratulations')}}</p>
      <p>
        {{$t('Redenvelope.Grab')}}<span id="redPacketAmount" class="yellow bigFont">{{ mey }}</span
        > {{$t('Redenvelope.meta')}}
      </p>
      <a href="javascript:;" @click="closeAll" class="close"></a>
    </div>
    <!-- henbaoqian  很抱歉 -->
    <div class="henbaoqian divIndex" v-if="henbaoqian">
      <p id="henbaoqian">{{ message }}</p>
      <div id="viewRules" class="rules" @click="$parent.goNav('/recharge')"> {{$t('Redenvelope.Recharge')}}</div>
      <a href="javascript:;" @click="closeAll" class="close"></a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userredpacket',
  data() {
    return { show: false, redpacketList: [], page: 1, redpacketShowData: {}, userredpacket: { rules: [] }, weikaishi: false, end: false, mey: 0, zhongjiang: false, henbaoqian: false, message: '' };
  },
  created() {
    let that = this;
    that.getuserredpacket();
  },
  methods: {
    closeAll() {
      this.show = false;
      this.weikaishi = false;
      this.end = false;
      this.zhongjiang = false;
      this.henbaoqian = false;
      this.message = '';
    },
    changShow() {
      let that = this;

      // userredpacket.redPacketStatus  红包状态 READY-未开始 STARTING-进行中 END-结束
      // if (that.userredpacket.redPacketStatus == 'READY') {
      //   this.weikaishi = true;
      // }
      // if (that.userredpacket.redPacketStatus == 'END') {
      //   this.end = true;
      // }
      // if (that.userredpacket.redPacketStatus == 'STARTING') {
      //   that.getwelfare();
      // }
      if (that.userredpacket.sendnums <= 0) {
        that.henbaoqian = true;
        that.message = that.$t('Redenvelope.met');
        return;
      }
      that.getwelfare();
    },
    getwelfare() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            that.mey = res.data.redpacketmoney;
            that.getuserredpacket();
            that.zhongjiang = true;
          } else {
            that.henbaoqian = true;
            that.message = res.message;
          }

          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.showTost(0, that.$t('Redenvelope.Server'));
          that.$parent.hideLoading();
        });
    },

    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/userredpacket', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../static/css/layui.css';
@import '../../static/style/style.css';
@import '../../static/css/animate.min.css';
.activityInfo table td {
  line-height: 60px;
}
.rightFloat .currenTimePeriod .currenTime {
  position: absolute;
  display: block;
  bottom: 20px;
  left: 17px;
  width: 100%;
}
.redEnveFont {
  overflow: hidden;
  height: 158px;
  box-sizing: border-box;
  padding-top: 49px;
}
.zhongjiang {
  width: 461px;
}
.henbaoqian {
  background: url(/static/image/henbaoqian.png) no-repeat;
  width: 280px;
  background-size: 100% 100%;
  height: 447px;
  top: 50%;
  left: 0px;
  right: 0px;
  margin: 10px auto;
  padding: 145px 20px 0;
}
.henbaoqian p {
  margin-top: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/userredpacket.vue